"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = require("@nerdwallet/currency/components/Input");

var _Type = require("@nerdwallet/currency/components/Type");

var _classnames = _interopRequireDefault(require("classnames"));

var _Clear = _interopRequireDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Clear"));

var Typeahead = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Typeahead, _React$Component);

  var _super = (0, _createSuper2.default)(Typeahead);

  function Typeahead(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Typeahead);
    _this = _super.call(this, props);
    _this.state = {
      inputValue: '',
      currentHoverIndex: null,
      hideList: true
    };
    _this.handleTypeaheadInput = _this.handleTypeaheadInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.clearInput = _this.clearInput.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Typeahead, [{
    key: "getRowProps",
    value: function getRowProps(result, index) {
      return (0, _objectSpread2.default)({
        className: (0, _classnames.default)('typeahead-row', {
          hover: index === this.state.currentHoverIndex
        }),
        onClick: this.handleRowClick.bind(this, result, index),
        onMouseEnter: this.handleMouseOver.bind(this, index),
        key: result[this.props.primaryKey] || index
      }, this.props.rowProps);
    }
  }, {
    key: "getInputProps",
    value: function getInputProps() {
      var _this2 = this;

      return (0, _objectSpread2.default)({
        value: this.state.inputValue,
        placeholder: this.props.placeholder,
        onChange: this.handleTypeaheadInput,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        autoFocus: this.props.autoFocus,
        inputRef: function inputRef(input) {
          _this2.typeaheadInput = input;
        }
      }, this.props.inputProps);
    }
  }, {
    key: "handleRowClick",
    value: function handleRowClick(result, index, event) {
      event.stopPropagation();
      event.preventDefault(); // hide the results

      this.setState({
        hideList: true // rowSelected: true,

      });
      this.props.onClick(result, index, event);
    }
  }, {
    key: "calculateResults",
    value: function calculateResults(rowsLength) {
      // Only renders a total if typeahead results are visible
      if (!this.state.hideList) {
        if (rowsLength > 0) {
          return /*#__PURE__*/_react.default.createElement(_Type.Type, {
            component: "h4",
            size: 2,
            bold: true,
            className: "typeahead-total"
          }, rowsLength, " ", rowsLength === 1 ? 'Result' : 'Results');
        }

        return /*#__PURE__*/_react.default.createElement(_Type.Type, {
          component: "h4",
          size: 2,
          bold: true,
          className: "typeahead-total"
        }, "No Results");
      }

      return undefined;
    }
  }, {
    key: "handleTypeaheadInput",
    value: function handleTypeaheadInput(event) {
      var shouldHide = event.target.value.length === 0 && this.props.hideResultsNoInput;
      var hoverIndex = // eslint-disable-next-line react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
      event.target.value.length === 0 ? null : this.state.currentHoverIndex;
      this.props.typeaheadHandler(event.target.value);
      this.setState({
        inputValue: event.target.value,
        hideList: shouldHide,
        currentHoverIndex: hoverIndex
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (this.props.results.length > 0 && !this.state.hideList) {
        // Key 9 = Tab, Key 40 = ArrowDown
        if (event.which === 9 || event.which === 40) {
          event.preventDefault();
          var hoverRow = this.state.currentHoverIndex !== null ? this.state.currentHoverIndex + 1 : 0;
          this.transitionHoverState(hoverRow); // Key 38 = ArrowUp
        } else if (event.which === 38) {
          event.preventDefault();

          var _hoverRow = this.state.currentHoverIndex !== null ? this.state.currentHoverIndex - 1 : this.props.results.length - 1;

          this.transitionHoverState(_hoverRow); // Key 27 = Esc
        } else if (event.which === 27) {
          this.setState({
            hideList: true
          }); // Key 46 = Delete, Key 8 = Backspace
        } else if (event.which === 46 || event.which === 8) {
          this.setState({
            currentHoverIndex: null
          });
        } else if (event.which === 13) {
          event.preventDefault();

          if (this.state.currentHoverIndex !== null) {
            return this.handleRowClick(this.props.results[this.state.currentHoverIndex], this.state.currentHoverIndex, event);
          }

          this.props.onEnter(event, event.target.value);
          this.setState({
            hideList: true
          }); // remove focus from input when when not selecting a suggester
          // fixes Android bug of not dismissing keyboard popover

          this.typeaheadInput.blur();
        }
      }

      if (event.which === 13 && event.target.value) {
        event.preventDefault();
        this.props.onEnter(event, event.target.value); // remove focus from input when when not selecting a suggester
        // fixes Android bug of not dismissing keyboard popover

        this.typeaheadInput.blur();
      }

      return undefined;
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(index) {
      this.setState({
        currentHoverIndex: index
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        currentHoverIndex: null
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      if (this.state.inputValue.length > 0 || !this.props.hideResultsNoInput && this.props.results.length > 0) {
        this.setState({
          hideList: false
        });
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      if (this.state.currentHoverIndex === null) {
        this.setState({
          hideList: true
        });
      }
    }
  }, {
    key: "clearInput",
    value: function clearInput() {
      var _this3 = this;

      this.setState({
        inputValue: '',
        hideList: true,
        currentHoverIndex: null
      }, function () {
        if (_this3.props.onClearInput) {
          _this3.props.onClearInput();
        }

        _this3.typeaheadInput.focus();
      });
    }
  }, {
    key: "transitionHoverState",
    value: function transitionHoverState(hoverRow) {
      var currentHoverRow = hoverRow;

      if (currentHoverRow > this.props.results.length - 1) {
        currentHoverRow = 0;
      } else if (currentHoverRow < 0) {
        currentHoverRow = this.props.results.length - 1;
      }

      if (!this.isElementInContainer(hoverRow)) {
        this.resultsContainer.scrollTop = this.typeaheadList.getElementsByClassName('typeahead-row')[currentHoverRow].offsetTop;
      }

      this.setState({
        currentHoverIndex: currentHoverRow
      });
    }
  }, {
    key: "isElementInContainer",
    value: function isElementInContainer(hoverRow) {
      var row = this.typeaheadList.getElementsByClassName('typeahead-row')[hoverRow];
      var rect = row.getBoundingClientRect();
      var container = this.resultsContainer.getBoundingClientRect();
      return rect.bottom > container.top && rect.top < container.bottom;
    }
  }, {
    key: "renderRows",
    value: function renderRows() {
      var _this4 = this;

      return this.props.results.map(function (result, index) {
        return /*#__PURE__*/_react.default.createElement("div", _this4.getRowProps(result, index), _this4.props.renderRow(result));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var clearButtonClasses = "typeahead__clear-button ".concat(this.props.inputClearColor);
      var typeaheadContainerClasses = (0, _classnames.default)('typeahead-container', {
        'has-clear-button': this.props.showClearInput
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: typeaheadContainerClasses
      }, /*#__PURE__*/_react.default.createElement(_Input.Input, (0, _extends2.default)({
        fullWidth: true,
        className: "input-override"
      }, this.getInputProps())), this.props.showClearInput && /*#__PURE__*/_react.default.createElement("span", {
        className: clearButtonClasses,
        onClick: this.clearInput,
        onKeyDown: this.clearInput,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/_react.default.createElement(_Clear.default, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('typeahead-results-list', {
          hidden: this.state.hideList === true
        }),
        onMouseLeave: this.handleMouseLeave,
        ref: function ref(element) {
          _this5.resultsContainer = element;
        }
      }, this.calculateResults(this.props.results.length), /*#__PURE__*/_react.default.createElement("div", {
        className: "typeahead-rows",
        ref: function ref(element) {
          _this5.typeaheadList = element;
        }
      }, this.renderRows())));
    }
  }]);
  return Typeahead;
}(_react.default.Component);

exports.default = Typeahead;
(0, _defineProperty2.default)(Typeahead, "displayName", 'Typeahead');
(0, _defineProperty2.default)(Typeahead, "propTypes", {
  results: _propTypes.default.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  typeaheadHandler: _propTypes.default.func.isRequired,
  renderRow: _propTypes.default.func.isRequired,
  primaryKey: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  rowProps: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  inputProps: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  onClick: _propTypes.default.func,
  onEnter: _propTypes.default.func,
  autoFocus: _propTypes.default.bool,
  hideResultsNoInput: _propTypes.default.bool,
  onClearInput: _propTypes.default.func,
  showClearInput: _propTypes.default.bool,
  inputClearColor: _propTypes.default.oneOf(['white', 'neutral-dark', 'neutral-darker'])
});
(0, _defineProperty2.default)(Typeahead, "defaultProps", {
  autoFocus: true,
  rowProps: {},
  inputProps: {},
  hideResultsNoInput: true,
  inputClearColor: 'neutral-darker',
  primaryKey: 'id',
  placeholder: 'search',
  showClearInput: false,
  onEnter: function onEnter() {},
  onClick: function onClick() {},
  onClearInput: function onClearInput() {}
});